var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.documents.length > 0)?_c('p',[_vm._v(" Нажимая на кнопку выше, вы соглашаетесь с "),_c('LegalDocumentsLinks'),_vm._v(". ")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }